"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _UiContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UiContext"));
var _ProductDetailContext = _interopRequireDefault(require("./context/ProductDetailContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProductDetail = _ref => {
  let {
    children,
    data = {},
    fetchData = false,
    lang = "de",
    pagename
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const [attributes, setAttributes] = (0, _react.useState)({});
  const [combinationValues, setCombinationValues] = (0, _react.useState)({});
  const [productDetailData, setProductDetailData] = (0, _react.useState)({
    _loading: true
  });
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _location: {
      pathname = ""
    } = {}
  } = ui;
  let fetchURL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/Details.api?lang=").concat(lang, "&pagename=").concat(pagename);
  const detailData = (0, _useFetch.default)(fetchURL, [lang, pagename, pathname], pagename === pathname && fetchData);
  (0, _react.useEffect)(() => {
    setProductDetailData({});
  }, [pagename]);
  (0, _react.useEffect)(() => {
    if (!fetchData) return;
    setProductDetailData(detailData);
  }, [detailData, fetchData]);
  (0, _react.useEffect)(() => {
    if (fetchData || (0, _isEmpty.default)(data)) return;
    setProductDetailData(typeof data === "string" ? JSON.parse(data) : data);
  }, [data, fetchData]);
  return /*#__PURE__*/_react.default.createElement(_ProductDetailContext.default.Provider, {
    value: {
      attributes,
      combinationValues,
      productDetailData,
      setAttributes,
      setCombinationValues,
      setProductDetailData
    }
  }, children);
};
ProductDetail.propTypes = {
  data: _propTypes.default.object,
  fetchData: _propTypes.default.bool,
  lang: _propTypes.default.string,
  pagename: _propTypes.default.string.isRequired
};
var _default = exports.default = ProductDetail;